// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"f3ca210d","76":"bd4bd3cb","148":"3fabddcf","249":"0380c301","345":"184f1841","488":"c9a9094c","539":"d7117245","593":"853a0b53","728":"6906acc2","789":"578b602d"}[chunkId] + ".chunk.js";
};